document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.pdp-complete-your-look-or-multibuy-block');
  const productCode = window.pdp_cylom_pid;
  const targetProductCode = window.pdp_cylom_pid;
  
  const pdpMultibuyBlockSlider = function () {
    var swiper = new Swiper('.pdp-complete-your-look-slider', {
      direction: 'horizontal',
      loop: false,
      freeMode: false,
      slidesPerView: 3,
      spaceBetween: 12,
      autoHeight: true,
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 3
        },
        990: {
          slidesPerView: 3
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }
  function onProductsReady() {
    pdpMultibuyBlockSlider();
    setTimeout(function () {
      var productCards = document.querySelectorAll('.pdp-complete-your-look-slider .product-card');
      if (productCards && productCards.length) {
        productCards.forEach(productCard => {
          new window.theme.ProductCard(productCard, 'tagalys');
        });
      }
      var multibuyHeaderEl = ".complete-your-look-or-multibuy-header h2";
      //theme.CurrencySwitcher.switchCurrency(multibuyHeaderEl);
    }, 100);
    wrapper.classList.remove('loading');
  }

  if (window.pdp_cylom_type === 'multibuy' || window.pdp_cylom_type === 'native') {
    onProductsReady();
  } else if (window.pdp_cylom_type === 'xgen') {
    const pdpCompleteYourLookSlider = document.querySelector('.pdp-complete-your-look-slider .swiper-wrapper');

    const queryObject = {
      ids: [window.pdp_cylom_xgen_id]
    }
    if (productCode) {
      // Product code from recommendations
      queryObject.productCode = productCode
    }
    if (!productCode && targetProductCode) {
      // Target product code from recommendations
      queryObject.targetProductCode = targetProductCode
    }

    window.xgenCommon.recommend(queryObject).then((data) => {
      if( !data ) {
        wrapper.classList.add('hidden');
        return;
      }
      const result = data[window.pdp_cylom_xgen_id]
      const xgenProducts = result.items
      if (xgenProducts.length) {
        const upsellProducts = xgenProducts.map((item) => window.xgenCommon.unifyProduct(item))
        const availableProducts = upsellProducts.filter(product => product.variants.some(variant => variant.available));
        const productsNotInCart = availableProducts.filter(product => window.theme.cartPage.cart.items.every(cartItem => cartItem.product_id !== product.id));

        fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
          },
          body: `
          query Products @inContext(country: ${Shopify.country}) {
            ${productsNotInCart.map(product => `
              p_${product.id}: product(id: "gid://shopify/Product/${product.id}") {
                availableForSale
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                  }
                  minVariantPrice {
                    amount
                  }
                }
                createdAt
                description
                handle
                id
                images(first: 5) {
                  nodes {
                    url
                  }
                }
                onlineStoreUrl
                options(first: 100) {
                  id
                  name
                  optionValues {
                    name
                    firstSelectableVariant {
                      id
                    }
                  }
                }
                priceRange {
                  maxVariantPrice {
                    amount
                  }
                  minVariantPrice {
                    amount
                  }
                }
                productType
                publishedAt
                tags
                title
                updatedAt
                variants(first: 100) {
                  nodes {
                    availableForSale
                    compareAtPrice {
                      amount
                    }
                    id
                    image {
                      url
                    }
                    price {
                      amount
                    }
                    requiresShipping
                    sku
                    taxable
                    title
                    weight
                    weightUnit
                  }
                }
                vendor
              }
            `).join('\n')}
          }`
        }).then(response => response.json()).then(productsData => {
          if (!productsData.data) return;
          let newProducts = Object.keys(productsData.data).map(key => {
            const product = productsData.data[key];
            return product
          });
          newProducts = newProducts.filter(product => product.availableForSale);

          let newHtml = '';
          newProducts.forEach((product, index) => {
            if (index >= window.pdp_cylom_limit) return;
            const productId = product.id.split('/').pop();
            const selectedVariant = product.variants.nodes.find(variant => variant.availableForSale);
            const selectedVariantId = selectedVariant.id.split('/').pop();

            const productJson = {
              "id": productId,
              "title": product.title,
              "handle": product.handle,
              "published_at": product.publishedAt,
              "created_at": product.createdAt,
              "vendor": product.vendor,
              "type": product.type,
              "tags": product.tags,
              "price": product.priceRange.minVariantPrice.amount,
              "price_min": product.priceRange.minVariantPrice.amount,
              "price_max": product.priceRange.maxVariantPrice.amount,
              "available": product.availableForSale,
              "price_varies": product.priceRange.minVariantPrice.amount !== product.priceRange.maxVariantPrice.amount || false,
              "compare_at_price": product.compareAtPriceRange.minVariantPrice.amount || null,
              "compare_at_price_min": product.compareAtPriceRange.minVariantPrice.amount || null,
              "compare_at_price_max": product.compareAtPriceRange.maxVariantPrice.amount || null,
              "compare_at_price_varies": product.compareAtPriceRange.minVariantPrice.amount !== product.compareAtPriceRange.maxVariantPrice.amount,
              "images": product.images.nodes.map(image => image.url),
              "featured_image": product.images.nodes[0].url || null,
              "requires_selling_plan": false,
              "selling_plan_groups": [],
              "description": product.description,
              "content": product.description,
              "variants": product.variants.nodes.map(variant => ({
                "id": variant.id.split('/').pop(),
                "title": variant.title,
                "option1": product.options[0]?.optionValues[0]?.name || null,
                "option2": product.options[1]?.optionValues[0]?.name || null,
                "option3": product.options[2]?.optionValues[0]?.name || null,
                "sku": variant.sku,
                "requires_shipping": variant.requires_shipping,
                "taxable": variant.taxable,
                "featured_image": variant.image.url || null,
                "available": variant.availableForSale,
                "options": product.options.map(option => option?.optionValues[0]?.name || null) || [],
                "price": variant.price?.amount * 100 || null,
                "compare_at_price": variant.compareAtPrice?.amount || null,
                "price_min": variant.price?.amount * 100 || null,
                "price_max": variant.price?.amount * 100 || null,
                "price_varies": false,
                "compare_at_price_min": variant.compareAtPrice?.amount * 100 || null,
                "compare_at_price_max": variant.compareAtPrice?.amount * 100 || null,
                "compare_at_price_varies": false,
                "images": [variant.image.url] || [],
                "featured_image": variant.image.url || null,
              })),
              "options": product.options
            }
            const productScript = document.createElement('script');
            productScript.type = 'application/json';
            productScript.setAttribute('data-product-json', '');
            productScript.innerHTML = JSON.stringify(productJson);

            let isOnlyInStore = false;
            if (productJson.tags && Array.isArray(productJson.tags)) {
              isOnlyInStore = productJson.tags.some(tag => typeof tag === 'string' && tag.trim().toLowerCase() === 'in-store');
            }

            newHtml += `
            <div class="pdp-complete-your-look-item swiper-slide">
              <div
                class="product-card-v2 product-card product-card--quick "
                data-component="ProductCard"
                data-product-title="${product.title}"
                data-sku="${selectedVariant.sku}"
                data-value="${selectedVariant.price.amount * 100}"
                data-product-vendor="${product.vendor}"
                data-product-type="${product.type}"
              >
                <div class="product-card__image product-card__image--full">
                  <div class="product-card__image--wrapper">
                    <a
                      href="${product.onlineStoreUrl}"
                      title="${product.title}"
                      aria-label="${product.title}"
                    >
                      <img
                        class="component-image__image"
                        src="${product.images.nodes[0].url}"
                        loading="lazy"
                        width="1006"
                        height="1294"
                        alt="${product.title}"
                      >
                    </a>
                  </div>
                  <div class="product-card__actions ${isOnlyInStore ? 'hide' : ''}">
                    <form action="/cart/add" method="post" enctype="multipart/form-data" class="form">
                      <input type="hidden" name="quantity" value="1">
                      <select name="id" class="no-js" aria-label="Select variant" data-product-select="">
                        ${product.variants.nodes.map(variant => `<option ${variant.id.split('/').pop() === selectedVariantId ? 'selected="selected"' : ''} ${variant.availableForSale ? '' : 'disabled="disabled"'} value="${variant.id.split('/').pop()}">${variant.title}</option>`).join('')}
                      </select>

                      ${product.variants.length > 1 ? `
                        <div class="product-card__variant-picker product-card__variant-picker--with-options">
                          <span class="variant-picker__message visually-hidden" tabindex="-1">{{ 'cart.general.select_option' | t }}</span>
                          <div role="list" class="product-card__variants">
                          ${product.variants.nodes.map(variant => `<div role="listitem" class="product-card__variant-container">
                              <button class="btn btn--text add-product-variant" data-variant-id="${variant.id.split('/').pop()}" ${variant.availableForSale ? '' : 'disabled="disabled"'}>${variant.title}</button>
                            </div>`).join('')}
                          </div>
                          <div role="list" class="product-card__mobile-variants">
                          ${product.variants.nodes.map(variant => `<div role="listitem">
                              <button class="product-card__variant add-product-variant" data-variant-id="${variant.id.split('/').pop()}" ${variant.availableForSale ? '' : 'disabled="disabled"'} aria-label="{{ 'products.product.select_variant_for' | t: variant: variant.title, product_title: product.title }}"><span class="product-card__variant-text">${variant.title}</span> {% #theme-check-disable MissingTemplate %}{% render 'icon-checkmark' %}{% #theme-check-enable MissingTemplate %}</button>
                            </div>`).join('')}
                          </div>
                        </div>
                        ` : ''}

                      <button
                        class="btn--icon ${product.variants.length > 1 ? 'product__add--show-variants' : 'product__add'}"
                        type="submit"
                        name="add"
                        data-pid="${productId}"
                        data-add-to-cart=""
                        aria-label="Add to bag"
                      >
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75H6C3.92925 15.75 2.25 14.0707 2.25 12V6.47549C2.25 6.06149 2.586 5.72549 3 5.72549H15C15.414 5.72549 15.75 6.06149 15.75 6.47549V12C15.75 14.0707 14.0707 15.75 12 15.75Z" stroke="#111111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M12 8.25V3.75C12 2.92125 11.3288 2.25 10.5 2.25H7.5C6.67125 2.25 6 2.92125 6 3.75V8.25" stroke="#111111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </button>
                      ${product.variants.length > 1 ? `
                      <button class="product__add--mobile" type="submit" name="add" data-add-to-cart="" aria-label="Add to bag">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75H6C3.92925 15.75 2.25 14.0707 2.25 12V6.47549C2.25 6.06149 2.586 5.72549 3 5.72549H15C15.414 5.72549 15.75 6.06149 15.75 6.47549V12C15.75 14.0707 14.0707 15.75 12 15.75Z" stroke="#111111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M12 8.25V3.75C12 2.92125 11.3288 2.25 10.5 2.25H7.5C6.67125 2.25 6 2.92125 6 3.75V8.25" stroke="#111111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path class="path" fill="none" stroke="#fff" stroke-width="13" stroke-linecap="square" stroke-miterlimit="10" d="M100.2 40.2L51.5 88.8 29.8 67.5"></path>
                        </svg>
                      </button>
                      ` : ''}
                    </form>
                  </div>
                </div>

                <div class="product-card__info">
                  <div class="product-card__details">
                    <div class="product-card__text">
                      <h4 class="product-card__title">
                        <a href="${product.onlineStoreUrl}">
                          ${product.title}
                        </a>
                      </h4>
                      <div class="product-card__price" data-original-price="${selectedVariant.price.amount * 100}">
                        <span> </span>
                        <span data-product-price=""> <em class="currency-symbol">${window.theme.currentCurrencySymbol}</em>${slate.Currency.removeCurrencySymbol(slate.Currency.formatMoney(selectedVariant.price.amount * 100, theme.moneyFormat))}</span>
                      </div>
                    </div>
                  </div>
                </div>
                ${productScript.outerHTML}
              </div>
            </div>
          `;
          });
          pdpCompleteYourLookSlider.innerHTML = newHtml;
          onProductsReady();
        });
      } else {
        wrapper.classList.add('hidden');
      }
    }).catch(error => {
      console.error('Error fetching XGen products:', error);
      wrapper.classList.add('hidden');
    });
  }
});